const heroMapping = (data) => {

    const mappedData = {};

    const getMainImages = (heroSlide) => {
        const result = [];
        heroSlide.field_mobile_img[0] && result.push({
            size: 'mobile',
            url: heroSlide.field_mobile_img[0].url
        })
        heroSlide.field_tablet_img[0] && result.push({
            size: 'tablet',
            url: heroSlide.field_tablet_img[0].url
        })
        heroSlide.field_desktop_img[0] && result.push({
            size: 'desktop',
            url: heroSlide.field_desktop_img[0].url
        })
        return result;
    };

    const getBackgroundImages = (heroSlide) => {
        const result = [];
        heroSlide.field_mobile_bg_img[0] && result.push({
            size: 'mobile',
            url: heroSlide.field_mobile_bg_img[0].url
        })
        heroSlide.field_tablet_bg_img[0] && result.push({
            size: 'tablet',
            url: heroSlide.field_tablet_bg_img[0].url
        })
        heroSlide.field_desktop_bg_img[0] && result.push({
            size: 'desktop',
            url: heroSlide.field_desktop_bg_img[0].url
        })
        return result;
    };

    mappedData.slides = data.field_heroes.map((heroSlide) => {
        return {
            id: heroSlide.id,
            configuration: heroSlide.field_component_layout[0]?.value || '',
            mainImages: getMainImages(heroSlide),
            backgroundImages: getBackgroundImages(heroSlide),
            title: heroSlide.field_component_title[0]
              ? heroSlide.field_component_title[0].value
              : '',
            description: heroSlide.field_component_body[0]
              ? heroSlide.field_component_body[0].value
              : '',
            cta: heroSlide.field_component_cta[0]
              ? {
                  title: heroSlide.field_component_cta[0].title || '',
                  alt: heroSlide.field_component_cta[0].options.attributes['aria-label'] || '',
                  href: heroSlide.field_component_cta[0]?.url || '',
                  ariaLabel: heroSlide.field_component_cta[0].options.attributes['aria-label'] || '',
              }
              : {},
            desktopVideo: heroSlide.field_desktop_video[0] ?
                heroSlide.field_desktop_video[0].url : '',
            mobileVideo: heroSlide.field_mobile_video[0] ?
                heroSlide.field_mobile_video[0].url : '',
        }
    });

    return mappedData;

};


export default heroMapping;
